import { GENERIC_PROPERTY_PREFIX } from '../../search/constants'
import type { GenericMapping, GenericMappingByKey } from '../../search/types'

/**
 * Return the ES field path for a generic mapping entry.
 *
 * Accepts either:
 *  - (mapping, index) — for array-form GenericMapping where position = index
 *  - (entry)          — for GenericMappingByKey entries that carry their own `order`
 *
 * e.g. genericMappingToSpecificField({ order: 12, type: 'keyword' }) → 'generic.prop12.keyword'
 */
export function genericMappingToSpecificField(
  mapping: { type: string; order?: number },
  index?: number
): string {
  const i = index ?? mapping.order ?? 0
  return `generic.${GENERIC_PROPERTY_PREFIX}${i}.${mapping.type}`
}

export function genericMappingToSpecificFields(
  mapping: readonly GenericMapping[]
): string[] {
  return mapping.map(genericMappingToSpecificField)
}

export function getGenericMappingArrayFromGenericMappingByKey(
  genericMappingByKey: GenericMappingByKey
): GenericMapping[] {
  const sortedKeys = Object.keys(genericMappingByKey).sort(
    (a, b) => genericMappingByKey[a]!.order - genericMappingByKey[b]!.order
  )

  return sortedKeys.reduce((acc, key) => {
    const mapping = genericMappingByKey[key]
    if (mapping) {
      const { order, ...rest } = mapping
      acc.push({
        ...rest,
        key,
      })
    }
    return acc
  }, [] as GenericMapping[])
}
